import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-religion-branch-edit',
  templateUrl: './religion-branch-edit.component.html',
  styleUrls: ['./religion-branch-edit.component.css']
})
export class ReligionBranchEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
